import React from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import styleClasses from './css/LeftMenu.module.scss';

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

const LeftMenu = ({ musician, isGroup, setModalOpen, setArchiveModal, setPositionModal, setActivityModal, setContactModal, setMembersModal, isTablet }) => {
  // const { id: musicianId } = useParams(); // URL에서 musicianId 가져오기
  
  const menuData = [
    { title: 'Music Archive', path: 'music-archive' },
    { title: isGroup ? 'Members' : 'Position & Skill', path: isGroup ? 'members' : 'position-skill' }, // ✅ 조건 추가
    { title: 'Activity', path: 'activity' },
    { title: 'Contact', path: 'contact' },
  ];

  return (
    <div className={`${ styleClasses.leftMenu } ${ isTablet && styleClasses.tablet }`}>
      { menuData.map((menu, index) => (
      <div
        key={index}
        // to={`/musicard/${musicianId}/${menu.path}`} // 뮤지션 ID 포함
        className={ styleClasses.menuItem }
        onClick={() => {
          if (menu.path === 'music-archive') {
            setArchiveModal(true); setPositionModal(false); setActivityModal(false); setContactModal(false); setMembersModal(false); setModalOpen(true);
          } else if (menu.path === 'position-skill') {
            setArchiveModal(false); setPositionModal(true); setActivityModal(false); setContactModal(false); setMembersModal(false); setModalOpen(true);
          } else if (menu.path === 'members') {  // ✅ Members 팝업 추가
            setArchiveModal(false); setPositionModal(false); setActivityModal(false); setContactModal(false); setMembersModal(true); setModalOpen(true);
          } else if (menu.path === 'activity') {
            setArchiveModal(false); setPositionModal(false); setActivityModal(true); setContactModal(false); setMembersModal(false); setModalOpen(true);
          } else if (menu.path === 'contact') {
            setArchiveModal(false); setPositionModal(false); setActivityModal(false); setContactModal(true); setMembersModal(false); setModalOpen(true);
          }
        }}
      >
      <div
        className={ styleClasses.menuBackground }
        style={{ backgroundImage: `url("${musician.menuImages[index] || '/assets/images/Background Test 1.png'}")` }}
      ></div>
      <span className={ styleClasses.menuTitle }>{ menu.title }</span>
      </div>
    )) }
    </div>
  );
};

export default LeftMenu;
